import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { allOrdersAction } from '../../redux/actions/orderActions';
import { useSearchParams } from 'react-router-dom';

const Filters = ({ page, setPage, dateFrom, dateTo }) => {


    const dispatch = useDispatch()

    const { user } = useSelector(state => state.verifyEmailStore);
    const { message } = useSelector(state => state.order)




    const [searchParams, setSearchParams] = useSearchParams();



    const [filter_count, setFilter_count] = useState(0);
    const [perPage, setPerPage] = useState('10');
    const [seller_id, setSeller_id] = useState('');
    const [pm_id, setPm_id] = useState('');
    const [productID, setProductId] = useState('');
    const [order_id, setOrder_id] = useState("");






    useEffect(() => {

        const query = {}

        if (pm_id) query.pm_id = pm_id
        if (seller_id) query.seller_id = seller_id
        if (productID) query.productID = productID
        if (order_id) query.order_id = order_id
        if (perPage) query.perPage = perPage

        query.page = page

        // 🚫 Do NOT include dates in URL
        setSearchParams(query)

        // ✅ Add dates only for API
        if (dateFrom) query.dateFrom = dateFrom
        if (dateTo) query.dateTo = dateTo
        query.status = "COMPLETED,REVIEW_DELETED"


        dispatch(allOrdersAction(query))

    }, [
        dateFrom,
        dateTo,
        seller_id,
        productID,
        perPage,
        page,
        pm_id,
        order_id,
        dispatch,
        message,
        setSearchParams
    ])




    useEffect(() => {

        setPerPage(searchParams.get("perPage") || "10")
        setSeller_id(searchParams.get("seller_id") || "")
        setPm_id(searchParams.get("pm_id") || "")
        setProductId(searchParams.get("productID") || "")
        setOrder_id(searchParams.get("order_id") || "")


    }, [searchParams, setPage])






    useEffect(() => {

        setFilter_count(0)

        if (seller_id) {
            setFilter_count(prev => prev + 1)
        }
        if (pm_id) {
            setFilter_count(prev => prev + 1)
        }
        if (productID) {
            setFilter_count(prev => prev + 1)
        }
  
        if (order_id) {
            setFilter_count(prev => prev + 1)
        }

    }, [seller_id, pm_id, productID,  order_id])



    
        useEffect(() => {

        


            const Headerlinkks = document.querySelectorAll(".headerLinks");
            const subLinks = document.querySelectorAll(".subLinks");
            const element = document.getElementById("Commissions")
            const subElement = document.getElementById("outgoing-commissions");

            
            
    
    
    
            Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
            subLinks.forEach(el => el.classList.remove("activeSubLink"));
            element?.classList.add("activeHeaderLink");
            subElement?.classList.add("activeSubLink");
    
    
            document.title = `Outgoing Commissions - Admin Panel`;
    
        }, []);




    return (
        <Fragment>
            <div className="bg-white p-[2vmax] shadow-sm rounded-xl border border-gray-100 mb-[2vmax]">
                <div className="flex items-center justify-between mb-[1.5vmax]">
                    <div className="flex items-center gap-[0.5vmax]">
                        <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                        <h3 className="text-[1.2vmax] font-bold text-gray-700">Search Filters</h3>
                    </div>
                    
                    <div className="flex items-center gap-[1vmax]">
                        <span className='text-[0.9vmax] text-gray-500 font-medium' >Items per page:</span>
                        <div className="flex bg-gray-50 items-center border border-gray-200 p-[0.4vmax_0.8vmax] rounded-lg focus-within:border-indigo-400 transition-all">
                            <i className="fa-solid fa-list-ul text-gray-400 text-[0.9vmax]"></i>
                            <select 
                                className="pl-[0.5vmax] text-[0.95vmax] text-gray-600 outline-none bg-transparent cursor-pointer"
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(e.target.value)
                                    setPage(1)
                                }}
                            >
                                <option value="1">1</option>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-[1.2vmax]">
                    
                    {/* Order ID */}
                    <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                        <i className="fa-solid fa-hashtag text-gray-400 text-[1vmax]"></i>
                        <input 
                            type="text" 
                            className="w-full pl-[0.8vmax] text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                            placeholder="Order ID...."
                            value={order_id}
                            onChange={(e) => {
                                setOrder_id(e.target.value)
                                setPage(1)
                            }}
                        />
                    </div>

                    {/* Product ID */}
                    <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                        <i className="fa-solid fa-box text-gray-400 text-[1vmax]"></i>
                        <input 
                            type="text" 
                            className="w-full pl-[0.8vmax] text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                            placeholder="Product ID...."
                            value={productID}
                            onChange={(e) => {
                                setProductId(e.target.value)
                                setPage(1)
                            }}
                        />
                    </div>

                    {/* Seller ID */}
                    {user?.role !== 'PMM' &&
                        <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                            <i className="fa-regular fa-user text-gray-400 text-[1vmax]"></i>
                            <input 
                                type="text" 
                                className="w-full pl-[0.8vmax] text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                                placeholder="Seller ID...."
                                value={seller_id}
                                onChange={(e) => {
                                    setSeller_id(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    }

                    {/* PM ID */}
                    {user?.role !== 'PM' &&
                        <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                            <i className="fa-solid fa-user-tie text-gray-400 text-[1vmax]"></i>
                            <input 
                                type="text" 
                                className="w-full pl-[0.8vmax] text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                                placeholder="Pm ID...."
                                value={pm_id}
                                onChange={(e) => {
                                    setPm_id(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    }

                    {/* Clear Filters Button */}
                    {filter_count > 0 &&
                        <button 
                            onClick={() => {
                                setSeller_id("")
                                setPm_id("")
                                setProductId("")
                                setOrder_id("")
                            }}
                            className="flex items-center justify-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-xl text-[0.95vmax] font-bold text-gray-600 hover:bg-red-50 hover:text-red-600 hover:border-red-100 transition-all shadow-sm group"
                        >
                            <i className="fa-solid fa-rotate-right text-xs group-hover:rotate-180 transition-transform duration-500"></i>
                            Clear ({filter_count})
                        </button>
                    }
                </div>
            </div>
        </Fragment>
    )
}

export default Filters